<template>
  <div>
    <Button @click="handleSumMutasi">Sum Selected Data : Rp. {{ sumSelectedData }}</Button>
    <br /> <br />
    <HotTable ref="hotTableComponent" :settings="hotSettings" :data="paymentPendings">
    </HotTable>

    <Modal v-model="modalConfirmDelete"
      @on-cancel="confirmDescription = '', isDeletePending = false, isDeletePayment = false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="information-circled"></Icon>
        <span v-if="isDeletePending">Hapus Pending Dana</span>
        <span v-else="isDeletePending">Hapus Pembayaran</span>
      </p>
      <template>
        <div style="font-weight: bold;">
          <Row>
            <Col span="4"> Tanggal </Col>
            <Col span="1"> : </Col>
            <Col span="19"> {{ this.formConfimation.transactionDate }} </Col>
          </Row>
          <Row>
            <Col span="4"> Bank </Col>
            <Col span="1"> : </Col>
            <Col span="19"> {{ this.formConfimation.bankAccount }} </Col>
          </Row>
          <Row>
            <Col span="4"> Keterangan </Col>
            <Col span="1"> : </Col>
            <Col span="19"> {{ this.formConfimation.description }} </Col>
          </Row>
        </div>
        <hr /><br />
        <i> Ketik minimal 5 huruf untuk melanjutkan !</i>
        <Input style="display: none" v-model="this.formConfimation.id" />
        <Input v-model="confirmDescription" placeholder="notes" />
      </template>
      <div slot="footer">
        <Button type="error" size="large" long @click="postDeletePending"
          v-show="isDeletePending && confirmDescription.length >= 5">Hapus</Button>
        <Button type="error" size="large" long @click="postDeletePayment"
          v-show="isDeletePayment && confirmDescription.length >= 5">Hapus</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { HTTP } from '@/components/http-lib'
import Handsontable from "handsontable";
import { HotTable } from '@handsontable/vue';
import { registerAllModules } from "handsontable/registry";

const numeral = require('numeral');

registerAllModules();

import "handsontable/dist/handsontable.full.min.css";

const errorData = [];

export default {
  props: {
    indexId: Number, // handle beda jumlah kolom (per pending - all pending)
    headers: Array,
    columns: Array,
    pendings: Array,
    type: String
  },
  data() {
    this.columns.push(
      {
        data: "marking",
        type: "text",
        allowEmpty: false,
        strict: true,
      },
      {
        data: "markingGroup",
        type: "text",
        allowEmpty: false,
      },
      {
        data: "payment",
        type: "text",
        allowEmpty: false,
        renderer: this.buttonPayment
      },
      {
        data: "delete",
        type: "text",
        correctFormat: false,
        renderer: this.buttonDelete
      },
      {
        data: "id",
        type: "text",
        correctFormat: false,
      },
      {
        data: "isDeleted",
        type: "text",
        correctFormat: false,
      },
      {
        data: "giro",
        type: "text",
        correctFormat: false,
      },
      {
        data: "payment",
        type: "text",
        correctFormat: false,
      },
      {
        data: "isPayment",
        type: "text",
        correctFormat: false,
      }
    );

    return {
      tableData: {
        type: Array
      },
      headerPendings: this.headers,
      columnPendings: this.columns,
      paymentPendings: this.pendings,
      newPaymentPendings: [],
      uriType: this.type,
      errorData: [],
      isDataEdited: false,
      optionMarkings: [],
      optionGroupMarkings: [],
      modalConfirmDelete: false,
      formConfimation: {},
      confirmDescription: '',
      sumSelectedData: 0,
      isbuttonSum: false,
      isDeletePending: false,
      isDeletePayment: false,
      userRole: localStorage.getItem('user.role'),
      paymentUpdate: [],
      listMarking: [],
    }
  },
  components: {
    HotTable
  },
  methods: {
    getHotSettings() {
      this.hotSettings = {
        licenseKey: "non-commercial-and-evaluation",
        height: 600,
        width: "100%",
        stretchH: "all",
        dropdownMenu: true,
        filters: true,
        columnSorting: true,
        autoColumnSize: true,
        autoRowSize: true,
        colHeaders: true,
        outsideClickDeselects: false,
        contextMenu: {
          bgColor_row: {
            key: "subBgColorRow",
            name: "Background color row",
            submenu: {
              items: [
                {
                  key: "subBgColorRow:hot-white",
                  name: 'white',
                  callback: (k, o) => this.callbackColor(k, o),
                },
                {
                  key: "subBgColorRow:hot-red",
                  name: 'red',
                  callback: (k, o) => this.callbackColor(k, o),
                },
                {
                  key: "subBgColorRow:hot-blue",
                  name: 'blue',
                  callback: (k, o) => this.callbackColor(k, o),
                },
                {
                  key: "subBgColorRow:hot-yellow",
                  name: 'yellow',
                  callback: (k, o) => this.callbackColor(k, o),
                },
                {
                  key: "subBgColorRow:hot-orange",
                  name: 'orange',
                  callback: (k, o) => this.callbackColor(k, o),
                },
                {
                  key: "subBgColorRow:hot-green-soft",
                  name: 'green',
                  callback: (k, o) => this.callbackColor(k, o),
                },
                {
                  key: "subBgColorRow:hot-pink-soft",
                  name: 'pink',
                  callback: (k, o) => this.callbackColor(k, o),
                },
                {
                  key: "subBgColorRow:hot-purple-soft",
                  name: 'purple',
                  callback: (k, o) => this.callbackColor(k, o),
                },
              ],
            },
          },
        },
        selectionMode: 'multiple',
        manualColumnResize: true,
        hiddenColumns: {
          columns: [this.indexId, this.indexId + 1, this.indexId + 2, this.indexId + 3, this.indexId + 4]
        },
        colHeaders: this.headerPendings,
        minCols: "5",
        copyPaste: true,
        columns: this.columnPendings,
        afterChange: (item, action) => {
          this.updateDataAfterChange(item);
        },
        afterSetCellMeta: (row, col, action, item) => {
          // function for comment only
        },
        afterOnCellMouseUp: (event, coords, TD) => {
          this.sumData();
        },
        afterSelection: (row, column, row2, column2, preventScrolling, selectionLayerLevel) => {
          this.sumData();
        },
        cells: (row, col, prop) => {
          const data = this.paymentPendings[row];

          // const hot = this.$refs.hotTableComponent.hotInstance;
          var cellProperties = {};
          // coloring background cell
          if (data != undefined && data.color != null) {
            cellProperties.className = data.color;
          }

          // readonly column is deleted & is payment
          if ((data && data.isDeleted && (prop == 'marking' || prop == 'markingGroup')) || (data && data.payment && data.payment.length > 0 && (prop == 'marking' || prop == 'markingGroup'))) {
            cellProperties.readOnly = true;
          }

          return cellProperties;
        },
        afterViewRender: (stateFilter) => {
          if (this.$refs.hotTableComponent) {
            this.hotInstance = this.$refs.hotTableComponent.hotInstance;
            const filteredData = this.hotInstance.getData();

            this.newPaymentPendings = filteredData;
            this.$emit('setHotGiroData', filteredData)
          }
        },
      };
    },
    updateDataAfterChange(items) {
      let dataIdTemp = 0;
      if (items) {
        items.forEach((item) => {
          if (item[1] != "tanggal") {

            let row = item[0]; // get row
            // let pendingId = this.paymentPendings[row]["id"]; // get id will be change
            let pendingId = this.newPaymentPendings[row][11]; // get col[11] is id will be change
            let field = item[1]; // get column
            let newData = item[3]; // get new data
            // handle data multiple - copas data
            if (pendingId) {
              HTTP
                .post('paymentPending/updatePendingList', {
                  id: pendingId,
                  field: field,
                  newData: newData,
                })
                .then(response => {
                  this.$Message.success({
                    content: 'Edit Data Berhasil',
                    duration: 5
                  });
                })
                .catch(e => {
                  this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                  });
                  return
                })
            }

            this.paymentUpdate.map(value => {
              if (value.id == pendingId) {
                if (field == 'marking') {
                  HTTP
                    .post('marking/getBySnapshot', {
                      markingHeaderId: newData,
                      subbranchcode: this.subbranchcode
                    })
                    .then(response => {
                      let data = response.data;
                      const list = data.map(item => {
                        return {
                          value: item.markingheaderid,
                          label: item.markingheadercode
                        };
                      });
                      value.markingHeaderId = list[0].value
                    })
                } else if (field == 'markingGroup') {
                  setTimeout(() => {
                    this.refreshPage();
                  }, 500);
                }
              }
            })
            // setTimeout(() => {
            //   this.refreshPage();
            // }, 500);
          }
        });
      }
    },
    async updateDataBeforeChange(items) {
      // const hot = this.$refs.hotTableComponent.hotInstance.render();
    },
    async sumData() {
      const hot = this.$refs.hotTableComponent.hotInstance;
      const selected = hot.getSelected() || [];
      const data = [];
      var sum = 0;

      if (selected.length == 0) {
        this.sumSelectedData = 0
        return
      }

      for (let i = 0; i < selected.length; i += 1) {
        const item = selected[i];
        data.push(hot.getData(...item));
      }

      data[0].forEach((data) => {
        sum = parseInt(sum) + parseInt(data);
      })

      this.sumSelectedData = numeral(sum).format('0,0');
    },
    buttonPayment(instance, td, row, col, prop, value, cellProperties) {
      Handsontable.renderers.TextRenderer.apply(this, arguments); // Render the cell as text
      const button = document.createElement('button');
      const arrayData = this.paymentPendings[row];

      const data = {
        tanggal: arrayData.tanggalPembayaran,
        tanggalInput: arrayData.tanggal,
        keterangan: arrayData.keterangan,
        mutasi: arrayData.mutasi,
        bank: arrayData.bank,
        marking: arrayData.marking,
        markingGroup: arrayData.markingGroup,
        id: arrayData.id,
        isDeleted: arrayData.isDeleted,
        giro: arrayData.giro,
        payment: arrayData.payment,
        isPayment: arrayData.isPayment,
        noteCode: arrayData.noteCode
      }

      if (data && data.giro == true) {
        button.textContent = "Giro"; // Use the cell value as the button text
        button.classList.add('myBtGiro', 'btn-warning');
      } else {
        if (data && data.payment && data.payment.length > 0) { // change to delete button - already isPayment
          button.textContent = "Delete Payment";

          if (this.userRole == 'SUPERVISOR' || this.userRole == 'ADMINISTRATOR') {
            button.disabled = false;
            button.classList.add('myBtnDelete');
          } else {
            button.disabled = true;
            button.classList.add('myBtnDisabled');
          }

          button.classList.add('myBtnDisabled');
          button.disabled = true;

          // delete payment pending
          button.addEventListener('click', () => {
            if (col === 9) { // delete payment column
              this.formConfimation = {} // clear

              this.formConfimation.id = data.id
              this.formConfimation.transactionDate = data.tanggal
              this.formConfimation.bankAccount = data.bank
              this.formConfimation.description = data.keterangan

              this.isDeletePayment = true
              this.modalConfirmDelete = true
            }
          });
        } else if (data && data.isDeleted) {
          button.textContent = "Create";
          button.disabled = true;
          button.classList.add('myBtnDisabled');
        } else if (data && data.marking == '' && data.markingGroup == '') {
          button.textContent = "Create";
          button.disabled = true;
          button.classList.add('myBtnDisabled');
        } else if (data && data.isPayment) {
          button.textContent = "Create";
          button.disabled = true;
          button.classList.add('myBtnDisabled');
        } else { // create button payment
          button.textContent = "Create"; // Use the cell value as the button text
          button.classList.add('myBt', 'btn-primary');

          // Attach an event listener to handle button click
          button.addEventListener('click', () => {
            const dataPending = this.paymentUpdate.find(o => o.id == data.id); // Get the name from the clicked row
            this.redirectToDetails(dataPending); // Call the method to redirect to details page
          });
        }
      }

      // Clear the cell content and append the button element
      Handsontable.dom.empty(td);
      // handle last row - total mutasi
      if (instance.getData().length - 1 != row) {
        td.appendChild(button);
      }
    },
    redirectToDetails(paymentPending) {
      console.log("halo", paymentPending)
      let isGroup = paymentPending.markingGroupId ? true : false;
      let markingIdSelected = paymentPending.markingHeaderId ? paymentPending.markingHeaderId : paymentPending.markingGroupId;

      // jika marking & markingGroup keisi, utamakan marking
      if (paymentPending.markingHeaderId && paymentPending.markingGroupId) {
        isGroup = false;
        markingIdSelected = paymentPending.markingHeaderId;
      }

      this.$router.push({
        name: 'paymentPendingAdd',
        params: {
          paymentPendingId: paymentPending.id,
          paymentDateProp: paymentPending.tanggal,
          paymentPendingAmount: Number(paymentPending.mutasi),
          paymentPendingMarking: paymentPending.marking,
          paymentPendingMarkingGroup: paymentPending.markingGroup,
          markingIdSelected: markingIdSelected,
          isGroup: isGroup,
          uriType: this.uriType,
          bankAccountId: paymentPending.bankAccountId,
          startEndDate: paymentPending.startEndDate
        }
      });
      // Perform the redirection logic here
      // You can use Vue Router or any other method to navigate to the details page
      console.log(`Redirecting to details page for`, paymentPending);
    },
    buttonDelete(instance, td, row, col, prop, value, cellProperties) {
      // const hot = this.$refs.hotTableComponent.hotInstance;
      Handsontable.renderers.TextRenderer.apply(this, arguments); // Render the cell as text

      // Create a button element
      const button = document.createElement('button');
      button.textContent = "Delete"; // Use the cell value as the button text

      const arrayData = this.paymentPendings[row];

      const data = {
        tanggal: arrayData.tanggalPembayaran,
        tanggalInput: arrayData.tanggal,
        keterangan: arrayData.keterangan,
        mutasi: arrayData.mutasi,
        bank: arrayData.bank,
        marking: arrayData.marking,
        markingGroup: arrayData.markingGroup,
        id: arrayData.id,
        isDeleted: arrayData.isDeleted,
        giro: arrayData.giro,
        payment: arrayData.payment,
        isPayment: arrayData.isPayment,
        noteCode: arrayData.noteCode
      }

      // Disabled button isDeleted
      if (data && data.isDeleted == 1 || this.userRole != 'SUPERVISOR' || this.userRole != 'ADMINISTRATOR') {
        button.disabled = true;
        button.classList.add('myBtnDisabled');
      } else {
        button.classList.add('myBtnDelete');
      }

      if (data && data.payment && data.payment.length > 0) { // disabled button isPayment
        button.disabled = true;
        button.classList.add('myBtnDisabled');
      }

      // Attach an event listener to handle button click
      button.addEventListener('click', () => {
        // this.redirectToDetails(data); // Call the method to redirect to details page

        if (col === 10) {
          this.formConfimation = {} // clear

          this.formConfimation.id = data.id
          this.formConfimation.transactionDate = data.tanggal
          this.formConfimation.bankAccount = data.bank
          this.formConfimation.description = data.keterangan

          this.isDeletePending = true
          this.modalConfirmDelete = true
        }
      });

      // Clear the cell content and append the button element
      Handsontable.dom.empty(td);
      // handle last row for total mutasi
      if (this.paymentPendings.length - 1 != row) {
        td.appendChild(button);
      }
    },
    postDeletePending: function () {
      this.$Loading.start();
      let id = this.formConfimation.id;
      let confirmDescription = this.confirmDescription;
      const hot = this.$refs.hotTableComponent.hotInstance;
      const hotData = hot.getData()
      const indexData = hotData.findIndex(o => o[this.indexId] == id)


      let payload = {
        id: id,
        notesDeleted: confirmDescription
      }

      HTTP.post("paymentPending/delete", payload)
        .then(response => {

          this.$Loading.finish();
          this.$Message.success({
            content: 'Data pending dana berhasil dihapus !',
            duration: 3
          });

          hot.alter('remove_row', indexData)

        })
        .catch(e => {
          this.$Message.error('Delete Failed!');
        });

      this.modalConfirmDelete = false
      this.confirmDescription = ''
      this.isDeletePending = false
    },
    postDeletePayment: function () {
      this.$Loading.start();
      const paymentPendingId = this.formConfimation.id;

      HTTP
        .post('paymentPending/payment/delete', {
          paymentPendingId: paymentPendingId,
        })
        .then(response => {
          this.$Loading.finish();
          this.$Message.success({
            content: 'Pembayaran pending dana berhasil dihapus !',
            duration: 3
          });

          setTimeout(() => {
            location.reload();
          }, 2000);
        })
        .catch(e => {
          this.$Notice.error({
            title: "Error",
            desc: e,
            duration: 5
          });
        })

      this.modalConfirmDelete = false

    },
    reloadParent: function () {
      setTimeout(() => this.$emit("reloadParent"), 100);
    },
    actionPost() {
      const hot = this.$refs.hotTableComponent.hotInstance;
      this.tableData = hot.getData();

      let payload = [];

      let idx = -1;

      hot.getData().forEach((data) => {
        if (data[0] != null && data[1] != null) {
          let pending = {
            tanggal: data[0],
            keterangan: data[1],
            cabang: data[2],
            mutasi: data[3],
            saldo: data[4]
          }
          payload.push(pending)

          idx++;
        } else if (data[0] == null && data[1] != null) {
          payload[idx].mutasi = payload[idx].mutasi + data[3];
          payload[idx].keterangan = payload[idx].keterangan + ", " + data[1];
        }
      })

      HTTP
        .post('paymentPending/importFromArray', {
          payload
        })
        .then(response => {
          console.log(response)

          this.$Message.success({
            content: 'Pending List Saved',
            duration: 3
          });
        })
        .catch(e => {
          this.loadingPost = false
          this.$Notice.error({
            title: "Error",
            desc: e,
            duration: 5
          });
        })
    },
    afterValidate(item) {
      this.errorData = item;
      setTimeout(() => {
        this.checkTableData();
      }, 100);
    },
    checkTableData() {
      this.cellMeta = [];
      this.isDataEdited = true;
      let data = [];

      for (let i = 0; i < this.tableData.length; i++) {
        const e = this.tableData[i];
        console.log(this.tableData[i])
        data.push({
          ...e,
          username: e.username
            ? /^[0-9]*$/.test(e.username)
              ? `${e.username.slice(0, 19)}k`
              : e.username.slice(0, 20)
            : "",
          row: i,
        });
      }
      const filtered = data.filter((item) => {
        if (Object.keys(item).length <= 2 && Object.keys(item).length > 1) {
          console.log({ item });
        }
        return Object.keys(item).length > 2;
      });
      this.dataPayload = filtered.filter((item) => {
        return (
          item.tanggal != "" &&
          item.keterangan != "" &&
          item.mutasi != "" &&
          item.saldo != "" &&
          item.tanggal != null &&
          item.keterangan != null &&
          item.mutasi != null &&
          item.saldo != null
        );
      });
    },
    handleSumMutasi() {
      const hot = this.$refs.hotTableComponent.hotInstance;
      const selected = hot.getSelected() || [];
      const data = [];
      var sum = 0;

      if (selected.length == 0) {
        this.sumSelectedData = 0
        return
      }

      for (let i = 0; i < selected.length; i += 1) {
        const item = selected[i];
        data.push(hot.getData(...item));
      }

      data[0].forEach((data) => {
        sum = parseInt(sum) + parseInt(data);
      })

      this.sumSelectedData = numeral(sum).format('0,0');
    },
    refreshPage: function () {
      // this.toggleAllocateAll();
      this.$emit('refreshPage')
    },
    callbackColor(key, options) {
      const color = (key.split(':'))[1]

      const hotInstance = this.$refs.hotTableComponent.hotInstance;
      options.forEach(value => {
        const rowStart = value.start.row
        const rowEnd = value.end.row
        const totalCol = hotInstance.countCols()

        for (let i = rowStart; i <= rowEnd; i++) {
          const pendingId = hotInstance.getData()[i][11] // id ada di colom ke-11 di tablenya

          if (pendingId) {
            HTTP
              .post('paymentPending/updatePendingList', {
                id: pendingId,
                field: 'colour',
                newData: color,
              })
              .then(response => {
                this.$Message.success({
                  content: 'Edit Data Berhasil',
                  duration: 5
                });
              })
              .catch(e => {
                this.$Notice.error({
                  title: "Error",
                  desc: e,
                  duration: 5
                });
              })

            // Update warna secara lokal di this.paymentPendings
            const dataIndex = this.paymentPendings.findIndex(item => item.id === pendingId);
            if (dataIndex !== -1) {
              this.$set(this.paymentPendings, dataIndex, { ...this.paymentPendings[dataIndex], color: color });
            }
          }

        }
      })
      this.hotInstance.render();
    }
  },
  components: {
    HotTable
  },
  beforeMount() {
    this.getHotSettings();
    this.paymentUpdate = this.pendings
  },
  mounted() {
    Handsontable.renderers.registerRenderer('buttonPayment', this.buttonPayment); // Register the custom renderer
    Handsontable.renderers.registerRenderer('buttonDelete', this.buttonDelete);
    this.$refs.hotTableComponent.hotInstance.validateCells();
    this.$Loading.config({
      color: '#fff',
      failedColor: '#f0ad4e',
      height: 10
    });
  },
}

</script>

<style>
.handsontable .warning-bg {
  background-color: yellow;
}

.handsontable .default-bg {
  background-color: white;
}

.myBt {
  width: 92%;
  color: #fff;
  font-size: 12px;
  padding: 2px 7px;
  margin: 5px;
  background: #2d8cf0;
  border-radius: 3px;
  border: none;
  cursor: pointer;
}

.myBtGiro {
  width: 92%;
  color: #fff;
  font-size: 12px;
  padding: 2px 7px;
  margin: 5px;
  background: #f90;
  border-radius: 3px;
  border: none;
  cursor: pointer;
}

.myBtnDelete {
  width: 92%;
  color: #fff;
  font-size: 12px;
  padding: 2px 7px;
  margin: 5px;
  background: #ed3f13;
  border-radius: 3px;
  border: none;
  cursor: pointer;
}

.myBtnDisabled {
  width: 92%;
  color: #b9b9b9;
  font-size: 12px;
  padding: 2px 7px;
  margin: 5px;
  background: #eeeeee;
  border-radius: 3px;
  border: none;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// cPaymentPendingAll.vue?eff8738c